/*
 * @Author: chengyunxiao
 * @Date: 2023-05-18 10:58:01
 * @LastEditTime: 2024-08-23 16:57:47
 * @Description: Do not eidt
 */
import axios from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { Toast } from '@atom/atom-ui';
import { convertKeysToUnderscore, formatHumpLineTransfer, getUrlByPromise, reportError } from '@/utils/tools';

interface Result<T> {
  statusCode: number;
  statusMsg: string;
  data: T;
  result: T;
  code?: number;
  message?: string;
}
const ERROR_MSG = '活动太火爆了，请稍后再试~';
// 导出Request类，可以用来自定义传递配置来创建实例
export class Request {
  // axios 实例
  instance: AxiosInstance;
  // 基础配置，url和超时时间
  baseConfig: AxiosRequestConfig = {
    baseURL: '/',
    timeout: 10000,
    withCredentials: true,
  };

  constructor(config: AxiosRequestConfig) {
    // 使用axios.create创建axios实例

    this.instance = axios.create(Object.assign(this.baseConfig, config));

    this.instance.interceptors.request.use(
      async (reqconfig: InternalAxiosRequestConfig) => {
        // todo 备用域名处理
        // reqconfig.url = await getUrlByPromise(reqconfig.url || '');
        if (!reqconfig?.data?.doNotFormat){
          reqconfig.data = convertKeysToUnderscore(reqconfig.data || {});
          reqconfig.params = convertKeysToUnderscore(reqconfig.params || {});
        } else {
          delete reqconfig?.data?.doNotFormat;
        }
        return reqconfig;
      },
      // 请求错误，这里可以用全局提示框进行提示
      (err: any) => {
        Promise.reject(err);
        const error = {
          name: '接口请求异常',
          message: '接口请求异常',
          stack: `错误信息：${JSON.stringify(err)}`,
        };
        reportError(error);
      },
    );

    this.instance.interceptors.response.use(
      // 直接返回res，当然你也可以只返回res.data 系统如果有自定义code也可以在这里处理
      (res: AxiosResponse) => formatHumpLineTransfer(res.data) as AxiosResponse,
      // 这里用来处理http常见错误，进行全局提示这里是AxiosError类型，所以一般我们只reject我们需要的响应即可
      (err: any) => {
        const { status } = err.response;
        const SUCCESS_CODE = 200;
        const ERROR_CODE = 300;
        if (status < SUCCESS_CODE || status > ERROR_CODE) {
          Toast(ERROR_MSG);
          const error = {
            name: '接口响应异常',
            message: '接口响应异常',
            stack: `错误信息：${JSON.stringify(err)}`,
          };
          reportError(error);
        }
        return Promise.reject(err.response);
      },
    );
  }

  // 定义请求方法
  public request(config: AxiosRequestConfig): Promise<AxiosResponse> {
    return this.instance.request(config);
  }

  public async get<T = any>(url: string, config?: AxiosRequestConfig): Promise<Result<T>> {
    return this.instance.get(url, config);
  }

  public post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<Result<T>> {
    return this.instance.post(url, data, config);
  }

  public put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<Result<T>>> {
    return this.instance.put(url, data, config);
  }

  public delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<Result<T>> {
    return this.instance.delete(url, config);
  }

  /**
   * jsonp请求封装
   * @param url 请求地址
   * @param data 请求数据
   */
  public async jsonp<T = any>(url: string, data: any): Promise<Result<T>> {
    // 备用域名的处理
    const domainUrl = await getUrlByPromise(url);
    return new Promise((resolve, reject) => {
      window.$.ajax({
        data,
        type: 'get',
        url: domainUrl,
        async: false,
        dataType: 'jsonp',
        timeout: 3000,
        success: function success(res: any) {
          resolve(res);
        },
        error: function error(err: any) {
          reject(err);
        },
      });
    });
  }
}

// 默认导出Request实例
export default new Request({});
